import { render, staticRenderFns } from "./PieDiPagina.vue?vue&type=template&id=ff864568&"
import script from "./PieDiPagina.vue?vue&type=script&lang=js&"
export * from "./PieDiPagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports